import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "Components/Atoms/Button";
import ModuleSelector from "Components/Atoms/ModuleSelector";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import { useState } from "react";
import PopUpAddElements from "../Components/Molecule/PopUpAddElements";
import {
  createModule,
  selectError,
  selectIsNewUserPendingVerification,
  selectIsPendingVerificationAndHasOrganizations,
  selectLoading,
  selectLoadingAnimation,
  selectOrganizations,
} from "../Redux/UserSlice";
import Layout from "./Layout";
import WelcomeModal from "./components/WelcomeModal";

export default function Modules() {
  const [popUp, setPopUp] = useState<any>(null);
  const error = useAppSelector(selectError);
  const loading = useAppSelector(selectLoading);
  const loadingAnimation = useAppSelector(selectLoadingAnimation);
  const organizations = useAppSelector(selectOrganizations);
  const dispatch = useAppDispatch();
  const isNewUserPendingVerification = useAppSelector(
    selectIsNewUserPendingVerification
  );
  const isPendingVerificationAndHasOrganizations = useAppSelector(
    selectIsPendingVerificationAndHasOrganizations
  );

  if (!loading && error) {
    return (
      <Layout>
        <div className="m-auto mt-24 flex w-4/5 flex-col ">
          <h1 className="text-3xl">Something went wrong</h1>
          <p>please try again</p>
        </div>
      </Layout>
    );
  }

  if (loadingAnimation) {
    return (
      <Layout>
        <div className="m-auto flex h-screen w-screen flex-col justify-center">
          <FontAwesomeIcon icon={faCircle} bounce size="4x" />
        </div>
      </Layout>
    );
  }

  if (isNewUserPendingVerification) {
    return (
      <Layout>
        <div className="m-auto flex h-screen w-screen flex-col justify-center text-center">
          <div className="flex flex-col gap-2">
            <p>We’re excited to have you on board!</p>
            <p>
              Hang on while the organization that owns the subscription link
              verifies your account. You will be informed by email when this is
              done.
            </p>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      {isPendingVerificationAndHasOrganizations && <WelcomeModal />}
      {popUp !== null && (
        <PopUpAddElements
          type={"Module"}
          onSet={(type, val) => {
            dispatch(
              createModule({
                orgId: popUp,
                name: val.name,
                isLive: val.is_live,
                isFree: val.is_free,
              })
            );
            setPopUp(null);
          }}
          onCancel={() => setPopUp(null)}
        />
      )}
      <div className=" overflow-hidden">
        <div className="m-auto mt-24 w-4/5 ">
          <div className="flex h-[89vh] flex-col overflow-y-auto overflow-x-hidden p-2">
            {organizations.map((org, i) => {
              return (
                <div key={i}>
                  {org.modules.map((mod, i) => (
                    <div className="grid grid-cols-10" key={i}>
                      <div className="col-start-1 col-end-9">
                        <ModuleSelector
                          name={mod.module_name}
                          organizationId={org.organisation_id}
                          moduleId={mod.module_id}
                        />
                      </div>
                      {(org.user_role === "Admin" ||
                        org.user_role === "Superadmin" ||
                        org.user_role === "Editor") && (
                        <div className="col-start-9 col-end-11 pl-4">
                          <ModuleSelector
                            name="edit"
                            organizationId={org.organisation_id}
                            moduleId={mod.module_id}
                            edit={true}
                          />
                        </div>
                      )}
                    </div>
                  ))}
                  {(org.user_role === "Admin" ||
                    org.user_role === "Superadmin" ||
                    org.user_role === "Editor") && (
                    <div className="mt-4 pl-2" key={org.organisation_name}>
                      <Button
                        label={`ADD MODULE FOR ${org.organisation_name}`}
                        className="w-full"
                        onClick={() => setPopUp(org.organisation_id)}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
}
